import {ScratchBlocks} from '@hetao/scratch-core';
const categorySeparator = '<sep gap="36"/>';
const blockSeparator = '<sep gap="36"/>'; /* eslint-disable-line */
/* motion */
const stageSelected = ScratchBlocks.ScratchMsgs.translate( /* eslint-disable-line */
    'MOTION_STAGE_SELECTED',
    'Stage selected: no motion blocks'
);
/* looks */
const hello = ScratchBlocks.ScratchMsgs.translate('LOOKS_HELLO', 'Hello!'); /* eslint-disable-line */
const hmm = ScratchBlocks.ScratchMsgs.translate('LOOKS_HMM', 'Hmm...'); /* eslint-disable-line */
/* sensing */
const name = ScratchBlocks.ScratchMsgs.translate('SENSING_ASK_TEXT', 'What\'s your name?'); /* eslint-disable-line */
/* operators */
const apple = ScratchBlocks.ScratchMsgs.translate('OPERATORS_JOIN_APPLE', 'apple'); /* eslint-disable-line */
const banana = ScratchBlocks.ScratchMsgs.translate('OPERATORS_JOIN_BANANA', 'banana'); /* eslint-disable-line */
const letter = ScratchBlocks.ScratchMsgs.translate('OPERATORS_LETTEROF_APPLE', 'a'); /* eslint-disable-line */

const xmlOpen = '<xml style="display: none">';
const xmlClose = '</xml>';
export const INCLUDED_EXTENSIONS = ['text2speech', 'speech2text', 'translate', 'doodleSense', 'txt2img', 'aichat','ailab'];
export const splitOutXml = xml => {
    const xmlObj = eval(`(${xml})`) || {}; // eslint-disable-line
    const extXmlObj = {};
    const standardXmlObj = {};
    for (const key in xmlObj) {
        if (INCLUDED_EXTENSIONS.includes(key)) {
            extXmlObj[key] = xmlObj[key];
        } else {
            standardXmlObj[key] = xmlObj[key];
        }
    }
    return {extXmlObj, standardXmlObj};

};
// 积木块白名单现有逻辑是只要有配置的project.xml就会走入白名单匹配，但只会展示配置了的积木块，所以如果没配置的积木块意味着就不会显示
// 那么就对于拓展积木块以前是不支持配置的，现在支持配置了，以前的课没配就让用户无法添加拓展吗，逻辑上是有bug的，所以拓展
// 这里需要不同的处理逻辑，配了category才进入筛选，所以配了category没有block就一个都不显示，配了category且有block就只显示含有的block
const filterAllowExtBlock = (categoriesXML, extXmlObj) => {
    if (Object.keys(extXmlObj).length === 0) {
        return categoriesXML;
    }
    const allowedCategoryXmls = [];

    const xmlDom = ScratchBlocks.Xml.textToDom(`<xml>${categoriesXML}</xml>`);
    for (let i = 0; i < xmlDom.childNodes.length; i++) {
        if (xmlDom.childNodes[i].nodeType !== Node.ELEMENT_NODE) continue;
        const category = xmlDom.childNodes[i];
        const categoryId = category.getAttribute('id');
        window.console.log('category id:', categoryId);
        if (extXmlObj[categoryId]) {
            const categoryDom = category.cloneNode();
            // eslint-disable-next-line no-eval
            const getWhiteListCategoryXml = eval(`(${extXmlObj[categoryId]})`);
            const whiteListCategoryXml = getWhiteListCategoryXml();
            const whiteListCategoryDom = ScratchBlocks.Xml.textToDom(whiteListCategoryXml);
            for (let j = 0; j < whiteListCategoryDom.childNodes.length; j++) {
                const block = whiteListCategoryDom.childNodes[j];
                categoryDom.appendChild(block.cloneNode(true));
            }
            // category中有block才添加到结果中
            if (Array.prototype.filter.call(categoryDom.childNodes, node =>
                node.nodeType === Node.ELEMENT_NODE).length > 0) {
              
                allowedCategoryXmls.push(ScratchBlocks.Xml.domToText(categoryDom));
            }

        } else {
            // 不在白名单中的category也添加到结果中（保持原有逻辑）
            allowedCategoryXmls.push(ScratchBlocks.Xml.domToText(category));
        }
    }
    window.console.log('allowedCategoryXmls:', allowedCategoryXmls);
    return allowedCategoryXmls.join('');
};

/**
 * @param {!boolean} isStage - Whether the toolbox is for a stage-type target.
 * @param {?string} targetId - The current editing target
 * @param {string?} categoriesXML - null for default toolbox, or an XML string with <category> elements.
 * @param {string?} toolboxXml - true for toolbox, or an XML string with <category> elements.
 * @returns {string} - a ScratchBlocks-style XML document for the contents of the toolbox.
 */
const whiteListToolboxXML = function (isStage, targetId, categoriesXML, toolboxXml) {
    const blocksObj = {};
    const {standardXmlObj:obj,extXmlObj} = splitOutXml(toolboxXml);// eslint-disable-line
    for (const prop in obj) {
        blocksObj[prop] = eval(`(${obj[prop]})`); // eslint-disable-line
    }
    return new Promise(resolve => {
        const gap = [categorySeparator];
        const everything = [];
        everything.push(xmlOpen);
        for (const prop in blocksObj) {
            everything.push(blocksObj[prop](isStage, targetId), gap);
        }
        if (categoriesXML) {
            everything.push(gap, filterAllowExtBlock(categoriesXML, extXmlObj));
        }
        everything.push(xmlClose);
        resolve({xml: everything.join('\n')});
    });
};

export function whiteListToolboxXMLSync (isStage, targetId, categoriesXML, toolboxXml) {
    const blocksObj = {};
    const obj = eval(`(${toolboxXml})`) || {}; // eslint-disable-line
    for (const prop in obj) {
        blocksObj[prop] = eval(`(${obj[prop]})`); // eslint-disable-line
    }
    const gap = [categorySeparator];
    const everything = [];
    everything.push(xmlOpen);
    for (const prop in blocksObj) {
        everything.push(blocksObj[prop](isStage, targetId), gap);
    }
    if (categoriesXML) {
        everything.push(gap, categoriesXML);
    }
    everything.push(xmlClose);
    return {xml: everything.join('\n')};
}

export default whiteListToolboxXML;
